import React, { forwardRef } from "react";
import Box, { BoxProps } from "../box/Box";

export type DividerProps = Omit<BoxProps, "aria-orientation"> & {
  orientation?: BoxProps["aria-orientation"];
};

/**
 * TODO: use theme sclaing for borderLeft / borderRight
 */
const Divider: React.FC<DividerProps> = forwardRef(({ orientation, ...props }, ref) => {
  const borderProps: BoxProps =
    orientation === "vertical"
      ? {
          borderLeft: "0.0625rem solid",
          borderLeftColor: "gray.200",
          height: "auto",
          mx: 2,
        }
      : {
          borderBottom: "0.0625rem solid",
          borderBottomColor: "gray.200",
          width: "auto",
          my: 2,
        };

  return <Box ref={ref} as="hr" aria-orientation={orientation} border="0" opacity={0.6} {...borderProps} {...props} />;
});

export default Divider;
